import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";
import { BaseContent } from "./types.ts";
import { utils } from "./utils.ts";

export const getContentList = defineQuery({
  input: z.object({
    table: z.string(),
    bypassCache: z.boolean().optional()
  }),
  handler: async ({ db }, { table }) => {
    const isProduction = process.env.NODE_ENV === 'production';
    const statusFilter = isProduction ? ["published"] : ["draft", "published"];
    
    // Try with date column first
    let { data, error } = await db
      .from(table.replaceAll("-", "_"))
      .select("*")
      .in("status", statusFilter)
      .order("date", { ascending: false, nullsFirst: false })
      .order("id", { ascending: false });
    
    // If date column doesn't exist, fallback to id only
    if (error && error.code === "42703") {
      ({ data, error } = await db
        .from(table.replaceAll("-", "_"))
        .select("*")
        .in("status", statusFilter)
        .order("id", { ascending: false }));
    }
    
    if (table === "service"){
      const liveVid = await utils.fetchLiveVideo("service");
      if (liveVid){
        const hasEntryAlready = data.some(entry => entry.date === liveVid.date)
        if (!hasEntryAlready) data.unshift(liveVid);
      }
    }

    if (error) throw error;
    return data as BaseContent[];
  },
});

export const getContent = defineQuery({
  input: z.object({
    table: z.string(),
    id: z.string().optional(),
    date: z.string().optional(),
    bypassCache: z.boolean().optional()
  }),
  handler: async ({ db }, { table, id, date }) => {
    const isProduction = process.env.NODE_ENV === 'production';
    const statusFilter = isProduction ? ["published"] : ["draft", "published"];
    var liveVid = null;
    
    if (table === "daily-bread"){
      liveVid = await utils.fetchLiveVideo("daily-bread");
    }
    if (table === "service"){
      liveVid = await utils.fetchLiveVideo("service");
    }
    
    console.log("id ", id)
    if (id) {
      const { data, error } = await db
        .from(table.replaceAll("-", "_"))
        .select("*")
        .in("status", statusFilter)
        .eq("id", id)
        .single();
      if (error) throw error;
      return data as BaseContent;
    } else if (date) {
      const { data, error } = await db
        .from(table.replaceAll("-", "_"))
        .select("*")
        .in("status", statusFilter)
        .eq("date", date)
      if (error) throw error;
      if (liveVid && data.length === 0) return liveVid
      return data[0] as BaseContent;
    } else {
      // Try with date column first
      let { data, error } = await db
        .from(table.replaceAll("-", "_"))
        .select("*")
        .in("status", statusFilter)
        .order("date", { ascending: false, nullsFirst: false })
        .order("id", { ascending: false });

      // If date column doesn't exist, fallback to id only
      if (error && error.code === "42703") {
        ({ data, error } = await db
          .from(table.replaceAll("-", "_"))
          .select("*")
          .in("status", statusFilter)
          .order("id", { ascending: false }));
      }

      // Check if liveVid exists and matches today's date
      if (table === "daily-bread" && liveVid) {
        const today = new Date().toISOString().split('T')[0];
        const hasEntryForToday = data.some(entry => entry.date?.startsWith(today));

        if (liveVid.date?.startsWith(today) && !hasEntryForToday) {
          return liveVid as BaseContent;
        }
      }

      if (error) throw error;
      if (data.length === 1) return data[0];
      return data as BaseContent[];
    }
  },
});